import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_menu_share",
  "use": "icon-ic_menu_share-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-ic_menu_share\"><path d=\"M8 1a.595.595 0 1 1 0 1.19A5.81 5.81 0 1 0 13.81 8 .595.595 0 1 1 15 8a7 7 0 1 1-7-7zm3.603 2.977a.585.585 0 0 1 .831-.822L13.46 4.18c.31.31.31.81 0 1.118l-1.025 1.025a.585.585 0 0 1-.826-.826l.173-.174h-.754c-2.052 0-2.749.874-2.749 3.516a.583.583 0 1 1-1.169 0c0-3.267 1.193-4.684 3.918-4.684h.754l-.178-.178z\" fill=\"#BDBDBD\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol